import { createElement } from 'react';
import baseToast from 'react-hot-toast';
import { CheckCircle2, Info, XCircle } from 'lucide-react';
import type { AxiosError } from 'axios';

export const toast = baseToast;

// Lucide icons (NOT emoji) for every toast variant, so notifications look
// consistent with the rest of the UI.
const toastIcon = {
  success: () => createElement(CheckCircle2, { size: 18, color: '#22c55e' }),
  error: () => createElement(XCircle, { size: 18, color: '#ef4444' }),
  info: () => createElement(Info, { size: 18, color: '#06b6d4' }),
};

/** Drop-in replacement for the old per-page showToast() helpers. Maps the
 *  three legacy variants onto react-hot-toast with a lucide icon each. */
export function showToast(
  msg: string,
  type: 'success' | 'error' | 'info' = 'success',
) {
  return baseToast(msg, { icon: toastIcon[type]() });
}

/** Pull the most human-readable message out of an axios/Nest error response. */
export function extractApiError(err: unknown, fallback = 'เกิดข้อผิดพลาด'): string {
  const e = err as AxiosError<{ message?: string | string[] }>;
  const msg = e?.response?.data?.message;
  if (Array.isArray(msg)) return msg[0] ?? fallback;
  if (typeof msg === 'string' && msg.trim()) return msg;
  if (e?.message) return e.message;
  return fallback;
}

export function toastError(err: unknown, fallback = 'เกิดข้อผิดพลาด') {
  baseToast(extractApiError(err, fallback), { icon: toastIcon.error() });
}
